module.exports = "<div class=\"container\">\r\n    <div class=\"image-wrapper\">\r\n        <figure>\r\n            <img [src]=\"imageUrl\">\r\n        </figure>\r\n    </div>\r\n    <p class=\"title\" translate>{{infoTitle}}</p>\r\n    <p class=\"description\" translate>{{infoDescription}}</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/intro-section/round-info/round-info.component.html
// module id = 787
// module chunks = 1